import { Button } from '@mui/material';

export default function AButton({...props}){
  return <Button {...props}></Button>
}
